import Splide from "@splidejs/splide";
import sliders from "../content/sliders";
import { preloadImage } from "../utils";
import { languages } from "../company";

//let lang = localStorage.getItem("user_language");
let lang = "en";
if (!lang) {
    lang = Object.keys(languages).find((language) => language === navigator.language?.slice(0, 2)) || "en";
    localStorage.setItem("user_language", lang);
}

export const callThumbnailSlider = (id) => {
    // Main slider initialization
    const main = new Splide(`#main-carousel-${id}`, {
        type      : 'fade',
        rewind    : true,
        pagination: false,
        arrows    : false,
        height    : 'auto',  // Allow the main slider to auto-adjust the height based on the content
        objectFit : 'contain', // Make sure the main image fits without cropping
    });

    // Thumbnail slider initialization
    const thumbnails = new Splide(`#thumbnail-carousel-${id}`, {
        fixedWidth  : 80,  // Fixed width for thumbnails
        fixedHeight : 60,  // Fixed height for thumbnails
        gap         : 10,  // Space between thumbnails
        rewind      : true,
        pagination  : false,
        isNavigation: true,
        focus       : 'center',  // Ensure the center thumbnail is focused
        breakpoints : {
            600: {
                fixedWidth : 60,
                fixedHeight: 44,
            },
        },
    });

    // Sync the main slider with the thumbnail slider
    main.sync(thumbnails);

    // Mount both sliders
    main.mount();
    thumbnails.mount();
};


export const callMainSlider = (id) => {
    const mainSlider =  new Splide( `#image-carousel-${id}`, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        arrows: false,
        autoplay: true,
        focus: "center",
    } );

    mainSlider.mount();

    // const socialBlock = document.querySelector(".header_social");
    // socialBlock.classList.remove("hide_block");
    // socialBlock.classList.add("header_social--visible");
}

const createSliderImage = (item) => {
    const listItem = document.createElement("li");
    listItem.classList.add("splide__slide");
    if (item.text && item.person) {
        const wrapper =  document.createElement("div");
        const icon =  document.createElement("div");
        const text = document.createElement("div");
        const author = document.createElement("div");

        wrapper.classList.add("mainPage_testimonials_wrap");
        text.classList.add("mainPage_testimonials_text");
        author.classList.add("mainPage_testimonials_author");
        icon.classList.add("mainPage_testimonials_icon");

        text.innerText = item.text;
        author.innerText = item.person;

        wrapper.appendChild(icon);
        wrapper.appendChild(text);
        wrapper.appendChild(author);
        listItem.appendChild(wrapper);
    } else {
        const image = document.createElement("img");
        image.src = item.image;
        image.alt = item.description;
        const description = document.createElement("div");
        description.innerText = item.description;
        listItem.appendChild(image);
        listItem.appendChild(description);
    }

    return listItem;
}

const createSliderList = (sliders, id, element, showDescription) => {
    const ul = document.createElement("ul");
    ul.classList.add("splide__list");

    sliders[id][element].forEach(item => {
        ul.appendChild(createSliderImage(item, showDescription));
    })

    return ul;
}

const createSliderSection = (name, sliders, id, element, showDescription) => {
    const section = document.createElement("section");
    section.id = `${name}-${element}`;
    section.classList.add("splide");

    const wrapper = document.createElement("div");
    wrapper.classList.add("splide__track");

    wrapper.appendChild(createSliderList(sliders, id, element, showDescription));
    section.appendChild(wrapper);

    return section;
}

export const createMainSlider = () => {
    const promoSection = document.querySelector(".page_contentWrapper");
    const sliderWrapper = document.createElement("div");
    const title = document.createElement("div");
    const underline = document.createElement("div");

    title.classList.add("main_block_title", "grey-color");
    underline.classList.add("menu-item-underline");
    sliderWrapper.classList.add("mainPage_slider_wrap");

    sliderWrapper.style.width = `${window.innerWidth * 0.70}px`

    window.addEventListener("load", () => {
        const width = document.querySelector(".mainPage_projects_block")?.offsetWidth;
        const padding = window.getComputedStyle(sliderWrapper).padding;

        if (width && padding) {
            sliderWrapper.style.setProperty('width', `calc(${width} - ${padding})`);
        }
    })

    title.innerText = "OUR TESTIMONIALS";

    sliderWrapper.appendChild(title);
    sliderWrapper.appendChild(underline);
    sliderWrapper.appendChild(createSliderSection("image-carousel", sliders, "testimonials", 0, false));
    promoSection.appendChild(sliderWrapper);
    callMainSlider(0);
}

export const createSlider = (projects, sliders) => {
    projects.forEach(project => {
        const url = (project.menuItem && project.menuItem[lang].url) || project[lang].url
        if (window.location.pathname.includes(url) && sliders[project.id]) {
            Object.keys(sliders[project.id]).forEach(element => {
                const sliderWrapper = document.createElement("div");

                sliderWrapper.appendChild(createSliderSection("main-carousel", sliders, project.id, element, true));
                sliderWrapper.appendChild(createSliderSection("thumbnail-carousel", sliders, project.id, element, false));

                const articleNode = new DOMParser().parseFromString(project.articles[element].body, "text/html").body;
                const firstNode = articleNode.firstElementChild;
                const lastNode = articleNode.lastElementChild;

                if (firstNode.outerHTML !== lastNode.outerHTML) {
                    firstNode.appendChild(sliderWrapper);
                    firstNode.classList.add("article_sliderWrapper--50");
                    project.articles[element].body = lastNode.outerHTML + firstNode.outerHTML;
                } else {
                    firstNode.appendChild(sliderWrapper);
                    project.articles[element].body = firstNode.outerHTML;
                }
            });
        }
    });
}

